<template>
  <div class="userstore" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div style="height:15px;"></div>
    <div class="user">
      <ul>
        <li v-for="(item,i) in setData">
          <img :src="item.avatar"/>
          <div class="info">
            <div class="A1">
              <span>{{item.name}}</span>
            </div>
            <div class="A2">联系电话：{{item.phone}}</div>
            <div class="A2">加入时间：{{item.createtime}}</div>
          </div>
        </li>
      </ul>
    </div>
    <div class="yhj" @click="toPush(store_id,'addstaff')">添加员工</div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        userData:[],
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        setData:[],
        store_id:0
      };
    },
    created(){
      this.userData = localStorage.getItem('user') == null ? [] : JSON.parse(localStorage.getItem('user'));
    },
    beforeMount() {
      this.baseUrl = this.$host;
      this.store_id =  this.$route.query.id
    },
    mounted() {
      this.beforeMount();
      this.ryUser();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },
      ryUser:function(){
        var id = this.$route.query.id
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/store/staff',
          params:{
            store_id:id
          }
        }).then(function(response){
          that.setData = response.data.data;
        }).catch(err=>{

        });
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .userstore{
    max-width:640px;
    background:#f7faff;
    margin:0 auto;
  }
  
  .userstore .user{
    width:92%;
    display:block;
    margin:0 auto;
  }
  .userstore .user li{
    background:#fff;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    width:100%;
    margin:0 auto;
    border-radius: 10px;
    margin-bottom:15px;
  }
  .userstore .user li img{
    float:left;
    width:70px;
    height:70px;
    margin:15px 5px 10px 15px;
    border-radius:50%;
  }
  .userstore .user li:after,.userstore .user li .isuservip:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .userstore .user li .info{
    float:left;
    width:72%;
    margin-top:12px;
    margin-left:5px
  }
  .userstore .user li .info .A1{
    font-size:15px;
    padding-bottom:7px;
    height:20px
  }
  .userstore .user li .info .A1 span:last-child{
    font-size:14px;
    float:right;
    color:#555;
    margin-top:3px
  }

  .userstore .user li .info .A1 span:first-child{
    float:left;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    width:45%
  }
  .userstore .user li .info .A2{
    font-size:14px;
    padding-bottom:5px;
    color:#999;
  }
  .userstore .yhj{
    position: fixed;
    width:84%;
    height:45px;
    line-height:45px;
    text-align:center;
    color:#fff;
    font-size:15px;
    background: #FF751A;
    bottom:20px;
    left:8%;
    border-radius: 45px;
  }
</style>